
import Vue from "vue";
import { Utilidades } from "./Util/Utilidades";

export default Vue.extend({
  name: "App",
  watch: {
    $route(to) {
      if (Utilidades.isNullOrUndefinedOrEmpty(to.meta.title))
        document.title = "FACTURAPP";
      else document.title = to.meta.title + " - FACTURAPP";
    },
  },
  data: () => ({}),
  methods: {},
});
